module.exports = __webpack_public_path__ + "img/copy.6b059310.svg";